import React from 'react';
import styles from "./registration-submitted.module.scss";
import {Row, Col, Button} from 'react-bootstrap';
import success from '../../../../../assets/order-summary-success.svg';
import {Auth} from "@aws-amplify/auth";

const RegistrationSubmitted = () => {
  const logout = async () => {
    await Auth.signOut({ global: true });
  }

  return (
    <div className={styles['form-section']} >
      <div className={styles['panel']}>
        <Row>
          <Col lg={12}>
            <div className={styles['heading']}>
              INVESTOR REGISTRATION APPLICATION SUBMITTED
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['section-spacing']}>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div>
              <img alt="Submitted" src={success} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['section-spacing']}>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={styles['next-button']}>
              <Button variant="secondary" onClick={() => logout()}>
                EXIT
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default RegistrationSubmitted;
